import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import * as store from "../../store/flyer-detail-add-page.store";
import { FlyerDetailAddPageView } from "../flyer-detail-add-page-view/flyer-detail-add-page-view.component";
import { useParams } from "react-router-dom";
import { FlyerDetailAddPageForm } from "../../types/flyer-detail-add-page-form/flyer-detail-add-page-form.interface";
import * as flyerDetailPageStore from "../../../flyer-detail-page/store/flyer-detail-page.store";

export const FlyerDetailAddPage = () => {
  const params = useParams<{ id: string }>();
  const templates = useSelector(store.getTemplates);

  useEffect(() => {
    if (!templates) {
      store.fetchTemplates();
    }
  }, [templates]);

  const goBack = () => {
    flyerDetailPageStore.navigateToFlyerPages(Number(params.id));
  };

  const createPage = (form: FlyerDetailAddPageForm) => {
    store.createPage(Number(params.id), form.templateId);
  };

  return (
    <FlyerDetailAddPageView
      templates={templates}
      isLoading={useSelector(store.isLoading)}
      onBack={goBack}
      onSubmit={createPage}
    />
  );
};
